import { ACTIONS } from "../../common/constants";

const earningsDataReducer = function (state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_EARNINGS_DATA:
      return action.data;
    default:
      return state;
  }
};

export default earningsDataReducer;
